import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { app } from "@microsoft/teams-js";
import { TeamsAuthProvider } from "./auth/TeamsAuthProvider";
import InboxPage from "./pages/InboxPage";
import TicketPage from "./pages/TicketPage";
import TeamQueuePage from "./pages/TeamQueuePage";
import TabConfigPage from "./pages/TabConfigPage";

function DeepLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    app.getContext().then((ctx) => {
      const subEntityId = ctx.page.subPageId;
      if (subEntityId && /^[a-zA-Z0-9_-]+$/.test(subEntityId)) {
        navigate(`/ticket/${subEntityId}`, { replace: true });
      }
    }).catch(() => {});
  }, []);

  return null;
}

export default function App() {
  return (
    <TeamsAuthProvider>
      <BrowserRouter>
        <DeepLinkHandler />
        <Routes>
          <Route path="/" element={<InboxPage />} />
          <Route path="/ticket/:id" element={<TicketPage />} />
          <Route path="/team-queue" element={<TeamQueuePage />} />
          <Route path="/tab-config" element={<TabConfigPage />} />
        </Routes>
      </BrowserRouter>
    </TeamsAuthProvider>
  );
}
